import React from "react"
import { SearchState } from "../../../types"
import { addValue, removeValue } from "../../../utils/filters"
import { useAlgoliaSearchState } from "../../controller/state"
import {
  AlgoliaCheckboxCategory,
  AlgoliaCheckboxOption,
  AlgoliaSearchParamTransformer,
} from "../../controller/state/types"
import CheckboxFilterCategory from "../CheckboxFilterCategory"
import { FacetOption } from "../types"

interface Props {
  maxScrollItems?: number
  minTextFilterItems?: number
  category: AlgoliaCheckboxCategory
}

const handleFilterUpdate = (
  category: AlgoliaCheckboxCategory,
  option: AlgoliaCheckboxOption,
  newValue: boolean,
  transformer: AlgoliaSearchParamTransformer
) => {
  transformer((state) => {
    if (newValue) {
      if (!state.filters) {
        state.filters = new Map<string, string[]>()
      }
      state.filters.set(
        option.key,
        addValue(state.filters.get(option.key) ?? [], option.value)
      )
      return state
    } else {
      if (!state.filters?.get(option.key)) {
        state.filters = new Map<string, string[]>()
      }
      state.filters.set(
        option.key,
        removeValue(
          state.filters.get(option.key) ?? [],
          option.value,
          category.options
            .filter((x) => x.selected && !x.disabled)
            .map((x) => x.value)
        )
      )
      return state
    }
  })
}

const getOptions = (
  category: AlgoliaCheckboxCategory,
  state: SearchState
): FacetOption[] => {
  const selectedFilters = state.filters?.get(category.key)
  return category.options.map(
    (x) =>
      ({
        ...x,
        selected: selectedFilters?.includes(x.value) ?? false,
      } as FacetOption)
  )
}

const TagFilterOptions = ({
  category,
  maxScrollItems,
  minTextFilterItems,
}: Props) => {
  const { updateSearchParams, searchParams } = useAlgoliaSearchState()

  return (
    <CheckboxFilterCategory
      options={getOptions(category, searchParams)}
      onOptionToggle={(option, newValue) =>
        handleFilterUpdate(
          category,
          option as AlgoliaCheckboxOption,
          newValue,
          updateSearchParams
        )
      }
      maxScrollItems={maxScrollItems}
      minTextFilterItems={minTextFilterItems}
    />
  )
}

export default TagFilterOptions
